import { Box } from "@mui/material";

export default function ResponsiveActionBar({ children }: any) {
  return (
    <Box
      sx={{
        display: "flex",
        flexWrap: "wrap",
        alignItems: "center",
        gap: 1,

        // DESKTOP → normal horizontal layout
        justifyContent: "flex-start",

        // MOBILE → force stacking
        "@media (max-width: 600px)": {
          flexDirection: "column",
          alignItems: "flex-start",
          width: "100%",
        },
      }}
    >
      {children}
    </Box>
  );
}
